/* ============================================================
   Mayalice — Configurateur Fête des Mères (port Shopify de preview-fete-meres.js)
   - 8 modèles (4 chaînes × 2 variantes avec/sans strass)
   - Doré uniquement
   - Max 4 pendentifs (charm, lettre perle, signe, fleur, pierre)
   ============================================================ */

(function () {
  'use strict';

  function whenReady(cb) {
    if (window.MAYA && window.MAYA_FM_ASSETS) return cb();
    setTimeout(function () { whenReady(cb); }, 30);
  }

  whenReady(function () {
    const { CHARMS, CHARMS_EXT, CHARM_LABELS, fetchDefaultCalibrations, loadCalibrations } = window.MAYA;
    const FM = window.MAYA_FM_ASSETS;
    const MAX_ITEMS = 4;

    // Liste complète des charms en doré (basiques + étendus)
    const ALL_CHARMS_IDS = [
      ...new Set([
        ...Object.values(CHARMS || {}),
        ...Object.values(CHARMS_EXT || {}),
      ]),
    ];

    // Multiplicateur de taille par type : la lettre est légèrement plus grosse que les autres charms.
    const ITEM_SIZE_MULT = { letterPearl: 1.18, charm: 1, signe: 1, fleur: 1, pierre: 1 };

    // Fallback si le core est en cache obsolète
    const _getItemPrice = window.MAYA.getItemPrice || function (it) {
      if (it && it.type === 'charm') {
        const map = { heart: 9, moon: 9, cross: 9, star5: 9, star8: 9 };
        return map[it.id] != null ? map[it.id] : 15;
      }
      return 9;
    };
    const _formatPrice = window.MAYA.formatPrice || function (eur) {
      return (typeof eur === 'number' && !isNaN(eur)) ? eur + ' €' : '';
    };

    /* --------- Scale correctif d'affichage par collier ---------
       Harmonise la taille visuelle du collier dans le stage.
       Mesuré sur l'épaisseur médiane de chaîne dans chaque PNG source.
       Ratios calculés pour ramener tous les colliers à une épaisseur
       perçue proche, sans déformation excessive (clamp 0.88..1.12). */
    const COLLIER_DISPLAY_SCALE = {
      "collier-1": 0.90,  // perles & paperclip strass (épais)
      "collier-2": 0.95,  // rolo strass
      "collier-3": 1.12,  // paperclip strass (très fin)
      "collier-4": 0.88,  // tennis diamants strass (le plus épais)
      "collier-5": 1.00,  // rolo (référence)
      "collier-6": 0.97,  // perles & paperclip
      "collier-7": 1.10,  // figaro (fin)
      "collier-8": 1.12,  // tennis diamants (fin)
      "collier-9": 0.90,  // tout perles strass (calé sur collier-1)
      "collier-10": 0.97, // tout perles (calé sur collier-6)
    };

    /* --------- Catalogue des colliers ---------
       `nouveau` : badge « Nouveau », et la carte n'apparaît que lorsque la
       variante Shopify est en stock. Maïlys lance le modèle en saisissant son
       stock, sans toucher au code. `?apercu-nouveaux` dans l'URL les montre
       quand même (et les rend sélectionnables) pour les vérifier avant. */
    const APERCU_NOUVEAUX = /[?&]apercu-nouveaux\b/.test(window.location.search);
    const COLLIERS = [
      { id: "collier-1", label: "Collier 1", desc: "Perles & paperclip · strass",       anchor: { x: 58, y: 86 } },
      { id: "collier-2", label: "Collier 2", desc: "Rolo · strass",                       anchor: { x: 50, y: 88 } },
      { id: "collier-3", label: "Collier 3", desc: "Paperclip · strass",                  anchor: { x: 50, y: 88 } },
      { id: "collier-4", label: "Collier 4", desc: "Tennis diamants · strass",            anchor: { x: 50, y: 88 } },
      { id: "collier-5", label: "Collier 5", desc: "Rolo · sans strass",                  anchor: { x: 50, y: 88 } },
      { id: "collier-6", label: "Collier 6", desc: "Perles & paperclip · sans strass",    anchor: { x: 58, y: 86 } },
      { id: "collier-7", label: "Collier 7", desc: "Figaro · sans strass",                anchor: { x: 50, y: 88 } },
      { id: "collier-8", label: "Collier 8", desc: "Tennis diamants · sans strass",       anchor: { x: 50, y: 88 } },
      { id: "collier-9", label: "Collier 5", desc: "Perles · strass",                     anchor: { x: 50, y: 89 }, nouveau: true },
      { id: "collier-10", label: "Collier 5.5", desc: "Perles · sans strass",             anchor: { x: 50, y: 89 }, nouveau: true },
    ];

    /* --------- État --------- */
    const state = {
      collier: null,
      items: [],
      activeCat: "charm",
    };

    /* --------- Refs DOM --------- */
    const previewStageEl = document.getElementById("previewStage");
    const collierImage = document.getElementById("collierImage");
    const lettersContainer = document.getElementById("lettersContainer");
    const cfgSteps = document.querySelectorAll(".cfg-step[data-step]");
    const cfgPanelSections = document.querySelectorAll(".cfg-panel-section");
    const stepCollierValue = document.getElementById("stepCollierValue");
    const stepCompositionValue = document.getElementById("stepCompositionValue");
    const summaryText = document.getElementById("summaryText");
    const confirmBtn = document.getElementById("confirmBtn");
    const CTA_LABEL_FINAL = (confirmBtn?.textContent || "Confirmer ma création").trim();
    const CTA_LABEL_CONTINUE = "Continuer ma création";
    let currentStep = "collier";
    const form = document.getElementById("maya-fm-add-form");
    const collierGrid = document.getElementById("collierGrid");
    const itemsBar = document.getElementById("itemsBar");
    const tabsEl = document.getElementById("tabs");
    const tabBtns = tabsEl ? tabsEl.querySelectorAll(".bola-tab") : [];
    const pickerEl = document.getElementById("picker");
    const zoomRange = document.getElementById("zoomRange");
    const zoomInBtn = document.getElementById("zoomInBtn");
    const zoomOutBtn = document.getElementById("zoomOutBtn");
    const inscriptionsBlock = document.getElementById("inscriptionsBlock");
    const inscriptionsList  = document.getElementById("inscriptionsList");
    const pricePersoEl = document.getElementById("pricePerso");
    const priceTotalEl = document.getElementById("priceTotal");
    // Prix de base du collier FM (injecté par la section liquid via data attribute)
    const FM_BASE_PRICE = parseFloat(
      document.querySelector("[data-fm-base-price]")?.dataset.fmBasePrice || ""
    ) || null;

    /* --------- Helpers d'assets --------- */
    function imgCharm(id) {
      // Supporte les charms statiques + dynamiques (Shopify-driven via PUA chars)
      if (window.MAYA && typeof window.MAYA.charmImgSrc === 'function') {
        return window.MAYA.charmImgSrc(id, 'dorees') || '';
      }
      return window.MAYA_ASSETS?.charm?.dorees?.[id] || '';
    }
    function imgLetterPearl(L) { return FM.letterPearl[L] || ''; }
    function imgSigne(idLong) { const n = idLong.split('-')[1]; return FM.signes[n] || ''; }
    function imgFleur(idLong) { const n = idLong.split('-')[1]; return FM.fleurs[n] || ''; }
    function imgPierre(idLong) { const n = idLong.split('-')[1]; return (FM.pierres || {})[n] || ''; }
    function imgCollier(id) { return FM.colliers[id] || ''; }
    function imgCollierCard(id) { return FM.colliersCards?.[id] || FM.colliers[id] || ''; }

    function itemImage(item) {
      if (item.type === "charm")       return imgCharm(item.id);
      if (item.type === "letterPearl") return imgLetterPearl(item.id);
      if (item.type === "signe")       return imgSigne(item.id);
      if (item.type === "fleur")       return imgFleur(item.id);
      if (item.type === "pierre")      return imgPierre(item.id);
      return "";
    }
    function itemSummaryLabel(item) {
      let base;
      if (item.type === "charm")            base = CHARM_LABELS[item.id] || item.id;
      else if (item.type === "letterPearl") base = item.id + " perle";
      else if (item.type === "signe")       base = "Signe " + item.id.split("-")[1];
      else if (item.type === "fleur")       base = "Fleur " + item.id.split("-")[1];
      else if (item.type === "pierre")      base = "Pierre " + item.id.split("-")[1];
      else base = item.id;
      if (item.text && item.text.trim()) base += " (" + item.text.trim() + ")";
      return base;
    }
    // Items éligibles à l'inscription personnalisée (mois/signe à graver sous le pendentif)
    function canHaveInscription(item) {
      return item.type === "signe" || item.type === "fleur" || item.type === "pierre";
    }

    /* --------- Navigation --------- */
    function isLocked(step) { return document.querySelector('.cfg-step[data-step="' + step + '"]')?.classList.contains("is-locked"); }
    function unlock(step) { document.querySelector('.cfg-step[data-step="' + step + '"]')?.classList.remove("is-locked"); }
    function markComplete(step) { document.querySelector('.cfg-step[data-step="' + step + '"]')?.classList.add("is-complete"); }
    function goToStep(step) {
      if (isLocked(step)) return;
      currentStep = step;
      cfgSteps.forEach((s) => s.classList.toggle("is-active", s.dataset.step === step));
      cfgPanelSections.forEach((sec) => { sec.hidden = sec.dataset.panel !== step; });
      // Refresh label/state du bouton selon l'étape
      if (typeof render === "function") render();
    }
    cfgSteps.forEach((btn) => btn.addEventListener("click", () => {
      const step = btn.dataset.step;
      const wasActive = btn.classList.contains('is-active');
      if (step === 'collier' && wasActive && state.collier) {
        state.collier = null;
        state.items = [];
        btn.classList.remove('is-complete');
        document.querySelector('.cfg-step[data-step="composition"]')?.classList.add('is-locked');
        render();
        return;
      }
      goToStep(step);
    }));

    /* --------- Grille des 8 colliers --------- */
    function getCollierPriceLive(collierId) {
      // Prix live depuis MAYA_PRICES (variant Shopify lié au collier), fallback FM_BASE_PRICE.
      const vid = fmCatalog?.products?.collier_fete_meres?.variants_by_collier?.[collierId];
      const live = vid != null ? window.MAYA_PRICES?.[vid] : null;
      return (typeof live === 'number' && !isNaN(live)) ? live : FM_BASE_PRICE;
    }
    function getCollierLabelLive(collierId, fallback) {
      // Label live depuis MAYA_VARIANT_TITLE (titre du variant Shopify), fallback hardcoded.
      const vid = fmCatalog?.products?.collier_fete_meres?.variants_by_collier?.[collierId];
      const live = vid != null ? window.MAYA_VARIANT_TITLE?.[vid] : null;
      return (typeof live === 'string' && live.trim()) ? live : fallback;
    }
    function getCollierVariantId(collierId) {
      return fmCatalog?.products?.collier_fete_meres?.variants_by_collier?.[collierId] || null;
    }
    function isCollierInStock(collierId) {
      if (APERCU_NOUVEAUX && COLLIERS.find((x) => x.id === collierId)?.nouveau) return true;
      const vid = getCollierVariantId(collierId);
      if (vid == null) return true;
      const avail = window.MAYA_VARIANT_AVAILABLE?.[vid];
      return avail !== false;
    }
    // Un modèle `nouveau` reste masqué tant que sa variante n'est pas en stock :
    // variante absente ou à 0, il n'existe pas encore pour la cliente.
    function isCollierHidden(c) {
      if (!c.nouveau || APERCU_NOUVEAUX) return false;
      const vid = getCollierVariantId(c.id);
      return vid == null || window.MAYA_VARIANT_AVAILABLE?.[vid] !== true;
    }
    // Ordre des cards = ordre des variantes Shopify (FM.collierOrder, injecté par
    // la section). Un collier dont la variante n'est pas dans la liste passe à la
    // fin, dans son ordre d'origine. Sans la liste (catalog pas encore chargé),
    // on garde l'ordre de COLLIERS.
    function orderedColliers() {
      const order = FM.collierOrder;
      if (!Array.isArray(order) || !order.length) return COLLIERS;
      return COLLIERS.map((c, i) => {
        const pos = order.indexOf(getCollierVariantId(c.id));
        return { c, key: pos === -1 ? order.length + i : pos };
      }).sort((a, b) => a.key - b.key).map((x) => x.c);
    }
    function buildCollierGrid() {
      if (!collierGrid) return;
      collierGrid.innerHTML = "";
      orderedColliers().forEach((c) => {
        if (isCollierHidden(c)) return;
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "chain-card";
        btn.dataset.collier = c.id;
        const priceLive = getCollierPriceLive(c.id);
        const labelLive = getCollierLabelLive(c.id, c.label);
        const inStock = isCollierInStock(c.id);
        const priceTag = priceLive != null
          ? '<span class="card-price">' + window.MAYA.priceHTML(priceLive, window.MAYA.getVariantCompareAt(getCollierVariantId(c.id))) + '</span>'
          : '';
        const outOfStockBadge = inStock
          ? ''
          : '<span class="card-out-of-stock">En rupture</span>';
        // Même gabarit doré que « Édition limitée » (maya-style.css, .card-limited).
        const newBadge = c.nouveau ? '<span class="card-limited">Nouveau</span>' : '';
        // Applique le même scale que dans le stage pour harmoniser les tailles
        // perçues des PNG (épaisseurs de chaîne différentes selon le modèle).
        const cardScale = COLLIER_DISPLAY_SCALE[c.id] || 1;
        const imgStyle = cardScale !== 1
          ? ' style="transform: scale(' + cardScale + '); transform-origin: center;"'
          : '';
        btn.innerHTML =
          '<span class="card-check" aria-hidden="true">✓</span>' +
          outOfStockBadge +
          newBadge +
          '<div class="card-image"><img src="' + imgCollierCard(c.id) + '" alt="' + labelLive + '"' + imgStyle + ' /></div>' +
          '<div class="card-label"><h3>' + labelLive + '</h3><p>' + c.desc + '</p>' + priceTag + '</div>';
        if (!inStock) {
          btn.classList.add("is-out-of-stock");
          btn.disabled = true;
          btn.title = "Ce collier est en rupture de stock";
        }
        btn.addEventListener("click", () => {
          if (!isCollierInStock(c.id)) return;
          state.collier = c.id;
          markComplete("collier");
          unlock("composition");
          render();
          if (typeof refreshDevPanel === "function") refreshDevPanel();
          // Pas d'auto-advance : l'utilisateur clique "Continuer ma création"
          // (bouton du footer) pour passer à l'étape composition.
        });
        collierGrid.appendChild(btn);
      });
      // Le nombre affiché suit les cartes réellement montrées (modèles masqués exclus).
      const nbModeles = collierGrid.querySelectorAll(".chain-card").length;
      document.querySelectorAll("[data-fm-nb-modeles]").forEach((el) => { el.textContent = nbModeles; });
    }

    /* --------- Items par catégorie --------- */
    function getCategoryItems(cat) {
      if (cat === "charm") {
        // Les 5 basiques (cross/heart/moon/star5/star8) + star-pearls ne sont pas
        // compatibles avec le nouveau collier FM. star-pave a été swap (quadrilobe
        // pierres-cœurs 2026-05-20) et est désormais compatible.
        // heart-clover : slug fantôme sans variant Shopify (cf commande #1700) — jamais affiché.
        const FM_EXCLUDED = ['cross', 'heart', 'moon', 'star5', 'star8', 'star-pearls', 'heart-clover'];
        // Ordre live (suit l'admin Shopify), fallback ALL_CHARMS_IDS
        const liveOrder = window.MAYA.getLiveCharmOrder ? window.MAYA.getLiveCharmOrder() : null;
        // Charms retirés du catalogue (variante Shopify supprimée) — masqués partout.
        const hidden = window.MAYA.CHARMS_HIDDEN_FROM_PICKER || new Set();
        const staticIds = (liveOrder || ALL_CHARMS_IDS)
          .filter((id) => !FM_EXCLUDED.includes(id) && !hidden.has(id));
        // Charms dynamiques dorés (Maïlys-driven) — filtrés par scope (metafield mayalice.configurateurs).
        let dynIds = (window.MAYA.getDynamicCharmIds && window.MAYA.getDynamicCharmIds('dorees')) || [];
        if (window.MAYA.isCharmInScope) dynIds = dynIds.filter((id) => window.MAYA.isCharmInScope(id, "fm"));
        const ids = [...staticIds, ...dynIds];
        return ids.map((id) => ({
          type: "charm",
          id,
          label: (window.MAYA.getLiveCharmLabel ? window.MAYA.getLiveCharmLabel(id, "dorees") : (CHARM_LABELS[id] || id)),
          src: imgCharm(id),
        }));
      }
      if (cat === "letterPearl") {
        return "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((L) => ({ type: "letterPearl", id: L, label: L, src: imgLetterPearl(L) }));
      }
      if (cat === "signe" || cat === "fleur" || cat === "pierre") {
        // Ordre live (priorité), fallback ordre constants, fallback ordre 1..12
        const liveOrder = cat === "signe"
          ? (window.MAYA.getLiveSigneOrder ? window.MAYA.getLiveSigneOrder() : null)
          : cat === "fleur"
            ? (window.MAYA.getLiveFleurOrder ? window.MAYA.getLiveFleurOrder() : null)
            : (window.MAYA.getLivePierreOrder ? window.MAYA.getLivePierreOrder() : null);
        const constOrder = cat === "signe" ? window.MAYA.SIGNE_ORDER
          : cat === "fleur" ? window.MAYA.FLEUR_ORDER : window.MAYA.PIERRE_ORDER;
        const fallback = Array.from({ length: 12 }, (_, i) => cat + "-" + (i + 1));
        const orderList = liveOrder || constOrder || fallback;
        const namesMap = cat === "signe" ? window.MAYA.SIGNE_NAMES
          : cat === "fleur" ? window.MAYA.FLEUR_MONTHS : window.MAYA.PIERRE_MONTHS;
        const liveLabel = cat === "signe" ? window.MAYA.getLiveSigneName
          : cat === "fleur" ? window.MAYA.getLiveFleurMonth : window.MAYA.getLivePierreName;
        const assetsMap = cat === "signe" ? FM.signes : cat === "fleur" ? FM.fleurs : (FM.pierres || {});
        return orderList.map((aid) => {
          const num = parseInt(aid.split("-").pop(), 10);
          return {
            type: cat,
            id: aid,
            label: liveLabel ? liveLabel(num) : ((namesMap && namesMap[num]) || (cat + " " + num)),
            src: assetsMap[num],
          };
        // Une pierre sans image (variante Shopify pas encore illustrée) n'est pas
        // proposée : sinon on afficherait une case vide dans le picker.
        }).filter((it) => it.src);
      }
      return [];
    }

    // Récupère le variantId Shopify d'un item de picker (pour le check inventory).
    function getVariantIdForItem(it) {
      const cat = window.MAYA_CATALOG;
      if (!cat) return null;
      if (it.type === "charm") {
        const fromCat = cat.products?.charms_dore?.variants?.find((x) => x.slug === it.id)?.id;
        if (fromCat) return fromCat;
        // Charm dynamique (Maïlys-driven) → variant ID via SSR injection
        if (window.MAYA.getDynamicCharmVariantId) return window.MAYA.getDynamicCharmVariantId('dorees', it.id) || null;
        return null;
      }
      if (it.type === "letterPearl") {
        return cat.products?.lettres_perle?.variants_by_letter?.[it.id] || null;
      }
      if (it.type === "signe") {
        return cat.products?.signes_astro?.variants?.find((x) => x.asset_id === it.id)?.id || null;
      }
      if (it.type === "fleur") {
        return cat.products?.fleurs_naissance?.variants?.find((x) => x.asset_id === it.id)?.id || null;
      }
      if (it.type === "pierre") {
        return cat.products?.pierres_naissance?.variants?.find((x) => x.asset_id === it.id)?.id || null;
      }
      return null;
    }
    function countSelected(type, id) {
      return state.items.filter((i) => i.type === type && i.id === id).length;
    }

    function buildPicker() {
      if (!pickerEl) return;
      pickerEl.innerHTML = "";
      const items = getCategoryItems(state.activeCat);
      if (!items.length) {
        const empty = document.createElement("div");
        empty.className = "charm-option-empty";
        empty.textContent = state.activeCat === "pierre"
          ? "Pierres de naissance bientôt disponibles"
          : "Bientôt disponible";
        pickerEl.appendChild(empty);
        return;
      }
      items.forEach((it) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "kb-key kb-charm has-price";
        if (it.type === "letterPearl") btn.classList.add("kb-letter", "has-letter-img");
        btn.dataset.type = it.type;
        btn.dataset.id = it.id;
        btn.title = it.label;
        const inner = document.createElement("span");
        inner.className = "kb-inner";
        // Tous les items (charms, signes, fleurs, lettres perles) sont en image
        const img = document.createElement("img");
        img.src = it.src;
        img.alt = it.label;
        if (it.type === "letterPearl") img.className = "kb-letter-img";
        inner.appendChild(img);
        btn.appendChild(inner);
        // Label (Bélier, Janvier, etc.) affiché AU-DESSUS du prix pour signes et fleurs
        if ((it.type === "signe" || it.type === "fleur" || it.type === "pierre") && it.label) {
          const labelTag = document.createElement("span");
          labelTag.className = "kb-month";
          labelTag.textContent = it.label;
          btn.appendChild(labelTag);
        }
        const priceTag = document.createElement("span");
        priceTag.className = "kb-price";
        const priceIt = it.type === 'charm' ? { ...it, color: state.color } : it;
        priceTag.innerHTML = window.MAYA.priceHTML(window.MAYA.getItemPrice(priceIt), window.MAYA.getItemCompare(priceIt), { prefix: '+' });
        btn.appendChild(priceTag);
        // Stock : grise si rupture (variant Shopify available === false)
        const inStock = it.type === "letterPearl"
          ? window.MAYA.isItemInStock("letterPearl", it.id)
          : it.type === "charm"
            ? window.MAYA.isCharmInStock("dorees", it.id)  // FM = uniquement charms or
            : window.MAYA.isItemInStock(it.type, it.id);
        // Compteur stock par exemplaire : si Maïlys a 1 Abeille, on n'en autorise qu'1 dans la compo.
        const variantId = getVariantIdForItem(it);
        const realStock = variantId ? window.MAYA.getVariantInventory(variantId) : null;
        const already = countSelected(it.type, it.id);
        let isMaxed = false;
        let badgeText = "";
        if (realStock !== null) {
          const remaining = realStock - already;
          if (remaining <= 0) {
            isMaxed = true;
            badgeText = "Épuisé";
          } else if (remaining === 1) {
            badgeText = "Dernier";
          } else if (remaining <= 3) {
            badgeText = "Plus que " + remaining;
          }
        }
        if (!inStock || isMaxed) {
          btn.classList.add("is-out-of-stock");
          btn.disabled = true;
          // Un item indisponible affiche toujours "Épuisé" (jamais "Dernier"/"Plus que N"),
          // y compris quand l'inventaire Shopify n'est pas tracké (available === false sans quantité).
          badgeText = "Épuisé";
        }
        if (badgeText) {
          const stockBadge = document.createElement("span");
          stockBadge.className = "kb-stock-badge" + (badgeText === "Épuisé" ? " kb-stock-badge--epuise" : "");
          stockBadge.textContent = badgeText;
          btn.appendChild(stockBadge);
        }
        btn.addEventListener("click", () => { if (!inStock || isMaxed) return; addItem(it.type, it.id); });
        pickerEl.appendChild(btn);
      });
    }

    function addItem(type, id) {
      if (state.items.length >= MAX_ITEMS) return;
      // Vérif stock : refuse si déjà au max d'exemplaires dispo
      const variantId = getVariantIdForItem({ type, id });
      if (variantId) {
        const stock = window.MAYA.getVariantInventory(variantId);
        if (stock !== null && countSelected(type, id) >= stock) return;
      }
      state.items.push({ type, id, text: "" });
      markComplete("composition");
      buildPicker();
      render();
    }
    function removeItem(idx) {
      state.items.splice(idx, 1);
      buildPicker();
      render();
    }

    /* --------- Rendu items (effet éventail) --------- */
    const ITEM_SIZE_PCT = 10;

    function getCollierAnchors() {
      if (!state.collier) return [];
      const cal = window.MAYA.getCollierFeteMeresCal(state.collier);
      if (cal.anchors && cal.anchors.length > 0) {
        return cal.anchors.filter(Boolean);
      }
      const c = COLLIERS.find((x) => x.id === state.collier);
      return [c?.anchor || { x: 50, y: 88 }];
    }

    function getCollierItemSize() {
      if (!state.collier) return ITEM_SIZE_PCT;
      return window.MAYA.getCollierFeteMeresCal(state.collier).size;
    }

    function pendantTilt(rank, N) {
      if (N <= 1) return 0;
      const cal = state.collier ? window.MAYA.getCollierFeteMeresCal(state.collier) : null;
      const FAN_MAX = cal?.fanRange ?? 90;
      // Inclinaison adaptative : scale linéaire de l'ouverture selon le nombre d'items.
      // N=2 → 33% du max (pendentifs légèrement écartés)
      // N=3 → 67% du max
      // N=4 → 100% du max (ouverture maximale)
      const scale = (N - 1) / 3;
      const FAN_RANGE = FAN_MAX * scale;
      const step = FAN_RANGE / (N - 1);
      return FAN_RANGE / 2 - rank * step;
    }

    function renderItems() {
      if (!lettersContainer) return;
      lettersContainer.innerHTML = "";
      if (!state.collier || state.items.length === 0) return;
      const anchors = getCollierAnchors();
      if (anchors.length === 0) return;
      const itemSize = getCollierItemSize();
      const N = state.items.length;

      const itemAnchors = state.items.map((_, idx) => {
        let anchorIdx;
        if (anchors.length >= 4 && N <= 4) {
          const offset = Math.floor((anchors.length - N) / 2);
          anchorIdx = offset + idx;
        } else {
          anchorIdx = idx % anchors.length;
        }
        return anchors[anchorIdx] || anchors[0];
      });

      const rankByIdx = new Map(
        [...itemAnchors.entries()]
          .sort((a, b) => a[1].x - b[1].x)
          .map(([origIdx], rank) => [origIdx, rank])
      );

      state.items.forEach((it, idx) => {
        const pt = itemAnchors[idx];
        const rank = rankByIdx.get(idx);
        const tilt = pendantTilt(rank, N);
        const sizeMult = ITEM_SIZE_MULT[it.type] || 1;
        const sz = itemSize * sizeMult;

        const img = document.createElement("img");
        img.src = itemImage(it);
        img.className = "bola-item-img";
        img.style.position = "absolute";
        img.style.width = sz + "%";
        img.style.height = "auto";
        img.style.left = (pt.x - sz / 2) + "%";
        img.style.top = pt.y + "%";
        img.style.transformOrigin = "center top";
        img.style.setProperty("transform", "rotate(" + tilt + "deg)", "important");
        img.style.animation = "none";
        img.style.cursor = "pointer";
        img.title = "Cliquer pour retirer";
        img.addEventListener("click", () => removeItem(idx));
        lettersContainer.appendChild(img);
      });
    }

    function render() {
      // Garde-fou : si le collier sélectionné est tombé en rupture (ou si le
      // click a contourné le disabled), on le déselectionne avant d'afficher.
      if (state.collier && !isCollierInStock(state.collier)) {
        state.collier = null;
        document.querySelector('.cfg-step[data-step="collier"]')?.classList.remove('is-complete');
        document.querySelector('.cfg-step[data-step="composition"]')?.classList.add('is-locked');
      }
      const ready = !!state.collier;
      if (!ready) {
        previewStageEl?.classList.add("is-empty");
      } else {
        previewStageEl?.classList.remove("is-empty");
        if (collierImage) collierImage.src = imgCollier(state.collier);
      }

      // Toggle no-chain + step-collier-active pour mode plein écran mobile sur l'étape Collier
      document.querySelectorAll('.maya-fm-host').forEach((host) => {
        host.classList.toggle('no-chain', !state.collier);
        host.classList.toggle('step-collier-active', currentStep === 'collier');
      });
      // Cache le bandeau prénoms sur l'étape Collier (gain d'espace mobile)
      document.body.classList.toggle('ma-hide-perso-names', currentStep === 'collier');

      collierGrid?.querySelectorAll(".chain-card").forEach((c) =>
        c.classList.toggle("is-active", c.dataset.collier === state.collier)
      );
      tabBtns.forEach((b) => b.classList.toggle("is-active", b.dataset.cat === state.activeCat));

      renderItems();

      if (itemsBar) {
        itemsBar.innerHTML = "";
        state.items.forEach((it, idx) => {
          const tag = document.createElement("button");
          tag.type = "button";
          tag.className = "bola-item-chip";
          tag.title = "Retirer";
          const img = document.createElement("img");
          img.src = itemImage(it);
          tag.appendChild(img);
          const x = document.createElement("span");
          x.className = "chip-x"; x.textContent = "×";
          tag.appendChild(x);
          tag.addEventListener("click", () => removeItem(idx));
          itemsBar.appendChild(tag);
        });
        for (let i = state.items.length; i < MAX_ITEMS; i++) {
          const slot = document.createElement("div");
          slot.className = "bola-item-slot";
          slot.textContent = "Slot " + (i + 1);
          itemsBar.appendChild(slot);
        }
      }

      renderInscriptions();
      updateSummary();

      // Bouton Continuer / Confirmer selon l'étape
      if (confirmBtn) {
        if (currentStep === "collier") {
          confirmBtn.textContent = CTA_LABEL_CONTINUE;
          confirmBtn.disabled = !state.collier;
        } else {
          confirmBtn.textContent = CTA_LABEL_FINAL;
          // Sur l'étape composition : actif si au moins 1 item (sinon le panier
          // contiendrait juste le collier nu, peu utile mais autorisé via Maïlys).
          confirmBtn.disabled = !ready;
        }
      }

      // Auto-zoom : 0 = 100%, 1+ = 250%
      maybeAutoZoom();
    }

    // Rebuild la liste d'inscriptions (un input par item signe/fleur/pierre).
    function renderInscriptions() {
      if (!inscriptionsList || !inscriptionsBlock) return;
      inscriptionsList.innerHTML = "";
      const editable = state.items.map((it, idx) => ({ it, idx })).filter(({ it }) => canHaveInscription(it));
      if (editable.length === 0) {
        inscriptionsBlock.hidden = true;
        return;
      }
      inscriptionsBlock.hidden = false;
      editable.forEach(({ it, idx }) => {
        const row = document.createElement("div");
        row.className = "fm-inscription-row";
        const img = document.createElement("img");
        img.src = itemImage(it);
        img.alt = "";
        img.className = "fm-inscription-thumb";
        row.appendChild(img);
        const inp = document.createElement("input");
        inp.type = "text";
        inp.className = "fm-inscription-input";
        inp.value = it.text || "";
        inp.placeholder = "Mois ou signe (ex: Octobre)";
        inp.maxLength = 18;
        inp.addEventListener("input", () => {
          state.items[idx].text = inp.value;
          updateSummary();
        });
        row.appendChild(inp);
        inscriptionsList.appendChild(row);
      });
    }

    function updateSummary() {
      if (stepCollierValue) {
        const c = COLLIERS.find((x) => x.id === state.collier);
        stepCollierValue.textContent = c ? c.label : "À choisir";
      }
      if (stepCompositionValue) {
        stepCompositionValue.textContent = state.items.length
          ? state.items.map(itemSummaryLabel).join(" + ")
          : "À renseigner";
      }
      if (summaryText) {
        if (!state.collier) {
          summaryText.textContent = "À composer";
        } else {
          const c = COLLIERS.find((x) => x.id === state.collier);
          const parts = [c?.label || "Collier", "Acier inoxydable doré"];
          if (state.items.length) parts.push(state.items.map(itemSummaryLabel).join(" + "));
          summaryText.textContent = parts.join(" · ");
        }
      }

      // Affichage des prix (items via MAYA.getItemPrice → prix Shopify dynamique soldé,
      // + accumulation du prix barré par élément pour le total promo)
      let persoTotal = 0, persoCompareTotal = 0;
      state.items.forEach((it) => {
        const item = it.type === 'charm' ? { ...it, color: state.color } : it;
        const unit = _getItemPrice(item);
        persoTotal += unit;
        const cmp = window.MAYA.getItemCompare(item);
        persoCompareTotal += (typeof cmp === 'number' && cmp > unit) ? cmp : unit;
      });
      if (pricePersoEl) {
        pricePersoEl.textContent = persoTotal > 0 ? "+" + _formatPrice(persoTotal) + " de personnalisation" : "";
      }
      // Prix de base : variant Shopify du wrapper FM (par collier sélectionné)
      let baseTotal = FM_BASE_PRICE, baseCompare = null;
      if (state.collier && fmCatalog) {
        const vid = fmCatalog.products?.collier_fete_meres?.variants_by_collier?.[state.collier];
        const live = window.MAYA.getVariantPrice?.(vid);
        if (typeof live === 'number' && live > 0) baseTotal = live;
        baseCompare = window.MAYA.getVariantCompareAt?.(vid) || null;
      }
      if (priceTotalEl) {
        if (baseTotal != null) {
          const grandNow = baseTotal + persoTotal;
          const baseOld = (typeof baseCompare === 'number' && baseCompare > baseTotal) ? baseCompare : baseTotal;
          const grandOld = baseOld + persoCompareTotal;
          priceTotalEl.innerHTML = '<span class="price-total-label">Total</span> <strong>' + window.MAYA.priceHTML(grandNow, grandOld > grandNow ? grandOld : null) + '</strong>';
        } else {
          priceTotalEl.textContent = "";
        }
      }
    }

    /* --------- Listeners --------- */
    tabBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        state.activeCat = btn.dataset.cat;
        buildPicker();
        render();
      });
    });

    let lastItemCount = -1;
    let lastCollier = null;
    let userOverrodeZoom = false;
    function applyZoom(value) {
      if (!previewStageEl) return;
      // Origine "center bottom" : le scale s'ancre au bas du stage, là où se
      // trouvent la chaîne et les items pendants → ils restent visibles, et
      // c'est le haut qui s'étend hors-cadre (sans conséquence visuelle).
      // Le facteur correctif COLLIER_DISPLAY_SCALE est multiplié au zoom utilisateur
      // pour harmoniser la taille visuelle entre les 8 colliers (épaisseurs sources
      // très différentes : tennis strass épais vs paperclip fin).
      const corrective = state.collier ? (COLLIER_DISPLAY_SCALE[state.collier] || 1.0) : 1.0;
      previewStageEl.style.transformOrigin = "center bottom";
      previewStageEl.style.transform = "scale(" + (value / 100 * corrective) + ")";
      previewStageEl.style.transition = "transform 360ms cubic-bezier(0.22, 0.61, 0.36, 1)";
    }
    function maybeAutoZoom() {
      const count = state.items.length;
      const collier = state.collier;
      // Redéclenche si le nombre d'items OU le collier sélectionné a changé.
      // Sur changement de collier, on doit ré-appliquer applyZoom() pour intégrer
      // le facteur correctif COLLIER_DISPLAY_SCALE même si le user a override le zoom.
      const collierChanged = collier !== lastCollier;
      if (count === lastItemCount && !collierChanged) return;
      lastItemCount = count;
      lastCollier = collier;
      // Si le collier change, on force le ré-rendu du zoom (avec scale correctif).
      // Si seul le count change et que l'user a override, on respecte son zoom.
      if (collierChanged) {
        const currentZoom = zoomRange ? parseFloat(zoomRange.value) || 100 : 100;
        applyZoom(currentZoom);
        if (userOverrodeZoom) return;
      } else if (userOverrodeZoom) {
        return;
      }
      // 2026-05-16 : zoom 1-item baissé 200 → 175 pour ne plus rogner la lune
      // sur les bords du stage (feedback Maïlys).
      const z = count === 0 ? 100
              : count === 1 ? 175
              : count === 2 ? 165
              : 150;
      if (zoomRange) zoomRange.value = z;
      applyZoom(z);
    }
    zoomRange?.addEventListener("input", (e) => {
      userOverrodeZoom = true;
      applyZoom(parseFloat(e.target.value));
    });
    zoomInBtn?.addEventListener("click", () => {
      userOverrodeZoom = true;
      zoomRange.value = Math.min(250, parseFloat(zoomRange.value) + 10);
      applyZoom(parseFloat(zoomRange.value));
    });
    zoomOutBtn?.addEventListener("click", () => {
      userOverrodeZoom = true;
      zoomRange.value = Math.max(100, parseFloat(zoomRange.value) - 10);
      applyZoom(parseFloat(zoomRange.value));
    });

    /* --------- Confirm → cart add Shopify --------- */
    async function captureAndUpload() {
      // Centralisé dans le core : clone restreint au stage + scale adaptatif +
      // timeout dur (cf. bug "Validation en cours… à l'infini" Safari/iOS 11/06/2026).
      if (!window.MAYA.capturePreview) return null;
      return window.MAYA.capturePreview(previewStageEl, { backgroundColor: '#FAF5EA' });
    }

    // Charge le catalog des variants Shopify pour le multi-items add-to-cart.
    let fmCatalog = null;
    async function loadFmCatalog() {
      if (fmCatalog) return fmCatalog;
      const catalogUrl = window.MAYA_FM_ASSETS.catalog;
      const res = await fetch(catalogUrl);
      fmCatalog = await res.json();
      return fmCatalog;
    }

    function variantIdForFmItem(cat, it) {
      if (it.type === "charm") {
        const prod = cat.products.charms_dore;
        const fromCat = prod?.variants?.find((v) => v.slug === it.id)?.id;
        if (fromCat) return fromCat;
        // Fallback : charm dynamique (Maïlys-driven via Shopify Admin) → variant ID via SSR
        if (window.MAYA.getDynamicCharmVariantId) return window.MAYA.getDynamicCharmVariantId('dorees', it.id) || null;
        return null;
      }
      if (it.type === "letterPearl") {
        const prod = cat.products.lettres_perle;
        return prod?.variants_by_letter?.[it.id] || null;
      }
      if (it.type === "signe") {
        return cat.products?.signes_astro?.variants?.find((v) => v.asset_id === it.id)?.id || null;
      }
      if (it.type === "fleur") {
        return cat.products?.fleurs_naissance?.variants?.find((v) => v.asset_id === it.id)?.id || null;
      }
      if (it.type === "pierre") {
        return cat.products?.pierres_naissance?.variants?.find((v) => v.asset_id === it.id)?.id || null;
      }
      if (it.type === "pierre") {
        return cat.products?.pierres_naissance?.variants?.find((v) => v.asset_id === it.id)?.id || null;
      }
      return null;
    }

    confirmBtn?.addEventListener("click", async () => {
      if (confirmBtn.disabled) return;
      // Étape Choix du collier : le bouton sert à passer à la perso.
      // On bloque le passage si le collier sélectionné est en rupture.
      if (currentStep === "collier") {
        if (!state.collier) {
          alert("Merci de choisir un collier avant de continuer.");
          return;
        }
        if (!isCollierInStock(state.collier)) {
          alert("Le collier sélectionné est en rupture de stock. Merci de choisir un autre modèle.");
          return;
        }
        goToStep("composition");
        return;
      }
      confirmBtn.disabled = true;
      const orig = confirmBtn.textContent;
      confirmBtn.textContent = "Préparation…";

      try {
        const c = COLLIERS.find((x) => x.id === state.collier);
        const composition = state.items.map(itemSummaryLabel).join(" + ") || "—";
        const inscriptions = state.items
          .map((it) => canHaveInscription(it) && it.text && it.text.trim()
            ? itemSummaryLabel({ ...it, text: "" }) + " : " + it.text.trim()
            : null)
          .filter(Boolean)
          .join(" · ");

        const cat = await loadFmCatalog();
        const collierVariantId = cat.products?.collier_fete_meres?.variants_by_collier?.[state.collier];
        if (!collierVariantId) {
          throw new Error("Variant collier introuvable : " + state.collier);
        }

        // Check stock du collier AVANT screenshot Cloudinary (évite "Préparation…"
        // bloqué puis "Load failed" sur cart/add — cf bug rupture Collier 1, mai 2026).
        if (window.MAYA_VARIANT_AVAILABLE?.[collierVariantId] === false) {
          alert("Ce collier est en rupture de stock. Merci de choisir un autre modèle.");
          confirmBtn.disabled = false;
          confirmBtn.textContent = orig;
          return;
        }

        const previewUrl = await captureAndUpload();
        const bundleId = "fm-" + Date.now();

        const items = [
          {
            id: collierVariantId,
            quantity: 1,
            properties: {
              "_bundle_id": bundleId,
              "_bundle_role": "primary",
              "Collier": c?.label || state.collier,
              "Finition": "Acier inoxydable doré",
              "Composition": composition,
              "Inscriptions": inscriptions || "",
              "_preview_url": previewUrl || "",
            },
          },
        ];

        // Composants → décrémentent les stocks individuels. CRITIQUE : on AVORTE
        // si un composant n'a pas de variant — jamais de paiement incomplet
        // silencieux (cf bug commande #1684 du 2026-05-19).
        const missing = [];
        state.items.forEach((it) => {
          const vid = variantIdForFmItem(cat, it);
          if (vid) {
            items.push({
              id: vid,
              quantity: 1,
              properties: {
                "_bundle_id": bundleId,
                "_bundle_role": it.type,
                ...(it.text && it.text.trim() ? { "Inscription": it.text.trim() } : {}),
              },
            });
          } else {
            missing.push(it.label || it.id || it.type);
          }
        });
        if (missing.length) {
          console.error("[maya-fm] composants sans variant Shopify", { missing, items: state.items });
          alert("Désolé, certains éléments de votre composition ne sont pas disponibles (" + missing.join(", ") + "). Retirez-les pour valider la commande.");
          confirmBtn.disabled = false;
          confirmBtn.textContent = orig;
          return;
        }

        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: items }),
        });
        if (!res.ok) {
          const text = await res.text().catch(() => "");
          let msg = "HTTP " + res.status;
          try { const err = JSON.parse(text); msg = err.description || err.message || msg; }
          catch { if (text) msg = text.slice(0, 200); }
          throw new Error(msg);
        }

        // Refresh drawer + open via helper centralisé
        if (window.MAYA.dispatchCartUpdateAndOpen) {
          await window.MAYA.dispatchCartUpdateAndOpen("maya-fm");
        } else {
          const drawer = document.querySelector("cart-drawer-component");
          if (drawer && typeof drawer.open === "function") drawer.open();
          else window.location.href = "/cart";
        }
      } catch (e) {
        alert("Désolé, ajout au panier impossible : " + e.message);
      } finally {
        // Toujours réactiver le bouton — y compris après un ajout réussi,
        // sinon impossible de composer un 2ᵉ collier sans recharger la page.
        confirmBtn.disabled = false;
        confirmBtn.textContent = orig;
      }
    });

    /* --------- Dev panel : calibration anchors + sliders --------- */
    const devToggleBtn = document.getElementById('devToggleBtn');
    const devPanel = document.getElementById('devPanel');
    const devCloseBtn = document.getElementById('devCloseBtn');
    const devColLabel = document.getElementById('devColLabel');
    const devCalibrateToggle = document.getElementById('devCalibrateToggle');
    const devAnchorsCount = document.getElementById('devAnchorsCount');
    const devClearAnchors = document.getElementById('devClearAnchors');
    const devSizeRange = document.getElementById('devSizeRange');
    const devSizeValue = document.getElementById('devSizeValue');
    const devFanRange = document.getElementById('devFanRange');
    const devFanValue = document.getElementById('devFanValue');
    const devExportBtn = document.getElementById('devExportBtn');

    let calibrateMode = false;

    function refreshDevPanel() {
      if (!state.collier || !devPanel) return;
      const c = COLLIERS.find((x) => x.id === state.collier);
      if (devColLabel) devColLabel.textContent = 'Collier sélectionné : ' + (c?.label || state.collier);
      const cal = window.MAYA.getCollierFeteMeresCal(state.collier);
      const placed = (cal.anchors || []).filter(Boolean).length;
      if (devAnchorsCount) devAnchorsCount.textContent = placed + '/4';
      if (devSizeRange) devSizeRange.value = cal.size;
      if (devSizeValue) devSizeValue.textContent = cal.size;
      if (devFanRange) devFanRange.value = cal.fanRange ?? 45;
      if (devFanValue) devFanValue.textContent = (cal.fanRange ?? 45) + '°';
      if (devCalibrateToggle) {
        devCalibrateToggle.textContent = calibrateMode ? 'ON' : 'OFF';
        devCalibrateToggle.classList.toggle('is-active', calibrateMode);
      }
      previewStageEl?.classList.toggle('is-calibrating', calibrateMode);
      drawAnchorOverlay();
    }

    function drawAnchorOverlay() {
      document.getElementById('anchorOverlay')?.remove();
      if (!calibrateMode || !state.collier) return;
      const cal = window.MAYA.getCollierFeteMeresCal(state.collier);
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.id = 'anchorOverlay';
      svg.setAttribute('viewBox', '0 0 100 100');
      svg.setAttribute('preserveAspectRatio', 'none');
      // Même référentiel que la chain-image et le letters-container
      // (bottom: 18%, aspect-ratio: 1/1) pour que l'overlay matche les pendentifs
      svg.style.position = 'absolute';
      svg.style.left = '0';
      svg.style.bottom = '18%';
      svg.style.width = '100%';
      svg.style.height = 'auto';
      svg.style.aspectRatio = '1 / 1';
      svg.style.pointerEvents = 'none';
      svg.style.zIndex = '20';
      (cal.anchors || []).forEach((pt, i) => {
        if (!pt) return;
        const c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        c.setAttribute('cx', pt.x);
        c.setAttribute('cy', pt.y);
        c.setAttribute('r', '1.5');
        c.setAttribute('fill', ['#d97706', '#0ea5e9', '#16a34a', '#dc2626'][i] || '#000');
        c.setAttribute('stroke', 'white');
        c.setAttribute('stroke-width', '0.4');
        svg.appendChild(c);
        const t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        t.setAttribute('x', pt.x);
        t.setAttribute('y', pt.y - 2.5);
        t.setAttribute('text-anchor', 'middle');
        t.setAttribute('font-size', '2.5');
        t.setAttribute('fill', '#000');
        t.setAttribute('font-weight', '700');
        t.textContent = i + 1;
        svg.appendChild(t);
      });
      previewStageEl?.appendChild(svg);
    }

    devToggleBtn?.addEventListener('click', () => {
      devPanel.hidden = !devPanel.hidden;
      if (!devPanel.hidden) refreshDevPanel();
    });
    devCloseBtn?.addEventListener('click', () => { devPanel.hidden = true; });

    devCalibrateToggle?.addEventListener('click', () => {
      calibrateMode = !calibrateMode;
      refreshDevPanel();
    });

    previewStageEl?.addEventListener('click', (e) => {
      if (!calibrateMode || !state.collier || !collierImage) return;
      const rect = collierImage.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      if (x < 0 || x > 100 || y < 0 || y > 100) return;
      const cal = window.MAYA.getCollierFeteMeresCal(state.collier);
      const placed = (cal.anchors || []).filter(Boolean).length;
      if (placed >= 4) {
        window.MAYA.clearCollierFeteMeresAnchors(state.collier);
        window.MAYA.setCollierFeteMeresAnchor(state.collier, 0, x, y);
      } else {
        window.MAYA.setCollierFeteMeresAnchor(state.collier, placed, x, y);
      }
      refreshDevPanel();
      render();
    });

    devClearAnchors?.addEventListener('click', () => {
      if (!state.collier) return;
      window.MAYA.clearCollierFeteMeresAnchors(state.collier);
      refreshDevPanel();
      render();
    });

    devSizeRange?.addEventListener('input', (e) => {
      const v = parseFloat(e.target.value);
      if (devSizeValue) devSizeValue.textContent = v;
      if (state.collier) {
        window.MAYA.setCollierFeteMeresSize(state.collier, v);
        render();
      }
    });

    devFanRange?.addEventListener('input', (e) => {
      const v = parseFloat(e.target.value);
      if (devFanValue) devFanValue.textContent = v + '°';
      if (state.collier) {
        window.MAYA.setCollierFeteMeresFanRange(state.collier, v);
        render();
      }
    });

    devExportBtn?.addEventListener('click', () => {
      // Export uniquement la section colliersFeteMeres (pas tout calibrations)
      const fmCalibrations = window.MAYA.calibrations.colliersFeteMeres || {};
      const json = JSON.stringify({ colliersFeteMeres: fmCalibrations }, null, 2);
      const blob = new Blob([json], { type: 'application/json' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'mayalice-fete-meres-calibrations.json';
      a.click();
      URL.revokeObjectURL(a.href);
    });

    /* --------- Init --------- */
    (async function init() {
      await fetchDefaultCalibrations();
      window.MAYA.calibrations = loadCalibrations();
      // Charge le catalog AVANT buildCollierGrid pour avoir les prix live par collier.
      try { await loadFmCatalog(); } catch (e) { /* fallback FM_BASE_PRICE */ }
      buildCollierGrid();
      buildPicker();

      // Pré-sélection au load : Collier 1 par défaut, ou premier en stock si C1 en rupture.
      const defaultCollier = isCollierInStock("collier-1")
        ? "collier-1"
        : (COLLIERS.find((c) => isCollierInStock(c.id))?.id || null);
      const collierStep = document.querySelector('.cfg-step[data-step="collier"]');
      const compoStep = document.querySelector('.cfg-step[data-step="composition"]');
      if (defaultCollier) {
        state.collier = defaultCollier;
        collierStep?.classList.add('is-complete');
        compoStep?.classList.remove('is-locked');
      } else {
        // Aucun collier en stock : on laisse l'utilisateur dans l'étape choix.
        state.collier = null;
      }

      render();

      // Stock : fetch en parallèle puis rebuild picker pour griser les ruptures
      (async () => {
        try {
          const [cat] = await Promise.all([
            loadFmCatalog(),
            window.MAYA.loadComponentStock(),
          ]);
          window.MAYA.buildStockMaps(cat);
          // Réordonne les collier-cards selon l'ordre Shopify
          window.MAYA.reorderCardsByShopify({
            handle: 'collier-fete-des-meres-personnalisable',
            productKey: 'collier_fete_meres',
            mapKey: 'variants_by_collier',
            mapMode: 'object',
            containerSelector: '#collierGrid, .fete-meres-grid',
            cardDataAttr: 'data-collier',
          });
          buildPicker();
        } catch (e) { console.warn('[FM] stock load failed', e); }
      })();
    })();
  });
})();
